import React, { useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg'
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";

const CustomerInputs = [
  {
    name: "source_name",
    label: "Source Name",
    type: "text",
    required: true,
   
    gridClass: "col-lg-4",
  },
  {
    name: "leadgroup",
    label: "Lead Group",
    type: "text",
    required: true,
    
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "status",
    type: "multiselectdropdown",
    required: true,
    options: [
        { label: "active", value: "Active" },
        { label: "inactive", value: "IN-Active" },
        
      ],
    gridClass: "col-lg-4",
  },

  
  
 
  
  
];


const AddLeadSource = () => {
  const [formData, setFormData] = useState({});
 
const navigate=useNavigate()
  const handleFormSubmit = (data) => {
   
    console.log("Form Data:", data);
  
  };



  return (
    <>
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add Lead Source</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Lead Source Details
        </span>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
        />
       
        
      </div>
    
      <div className="btncontainer mt-3">
      <button
  onClick={() => {
   
      handleFormSubmit(formData); 
   
       
    
  }}
  className="submit-btn"
>
  Submit
</button>

        </div>
    </>
  );
};

export default AddLeadSource;
